export default {
  'zh-CN': {
    clause:{
      Policies:'政策条款',
      TermsConditions:'通用条款',
      ServiceDisclaimer:'使用声明',
      PrivacyDisclaimer:'隐私政策',
      compliance :'廉正举报',
    }
  },
  'en-US':{
    clause:{
      Policies:'Policies',
      TermsConditions:'Terms and Conditions',
      ServiceDisclaimer:'Service Disclaimer',
      PrivacyDisclaimer:'Privacy Disclaimer',
      compliance :'Compliance Policies',
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/Clause_local.js